import {React, withStyles, lockr, uiConstants, Fragment} from '@api'
import {SYNC_SUBSCRIPTION, INCREMENTAL_SYNC} from '@design-board/graphql'
import {Backdrop, Snackbar, StyledComponentProps, Slide, Button, IconButton} from '@material-ui/core'
import {useStores} from '@modules'
import {site, ui} from '@stores'
import {observer} from 'mobx-react'
import {Subscription} from 'react-apollo'
import * as css from './SyncSnackbar.css'

function TransitionRight(props) {
  return <Slide {...props} direction="left"/>
}

export const SyncSnackbar: React.FC<{}> = observer(function SyncSnackbar() {
  const stores = useStores(), {catalog, userSettings} = stores
  return (userSettings?.sync?.showSnackbar && <Subscription subscription={SYNC_SUBSCRIPTION}>
      {({data, loading, error}) => {
        const {syncProgress: {inprogressIds}} = stores
        if(inprogressIds > 1){return null}
        if (!loading && data || (data && data.collectionSynced)) {
          site.initiateForceReloadTimerOnConfigChange()
          return <Fragment>
            <Backdrop
              classes={{root: css.backdrop}}
              open={true}
            />

            <Snackbar
              message={<span id="message-id">{data.collectionSynced?.message}</span>}
              open={true}
              TransitionComponent={TransitionRight}
              anchorOrigin={ui.settings.syncSnackbarLocation}
              className={css.snackbarContent}
              classes={{root: css.snackbarRoot}}
              action={[
                <Button key="undo" color="secondary" size="small" onClick={() => {site.forceReloadPage()}}>
                  REFRESH
                </Button>
              ]}
            />
          </Fragment>
        } else {
          return null
        }
      }}
    </Subscription>
  )
})

export const IncrementalSync: React.FC<{}> = observer(() => {
  const [open, setOpen] = React.useState(true)
  const AUTO_HIDE_DURATION = 10000
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false)
  }
  return <Subscription subscription={INCREMENTAL_SYNC}>
    {({data, loading}) => {
      if (!loading && data || (data && data.incrementalSync)) {
        return <Fragment>
          <Snackbar
            message={<span id="message-id">{data.incrementalSync?.message}</span>}
            open={open}
            autoHideDuration={AUTO_HIDE_DURATION}
            TransitionComponent={TransitionRight}
            onClose={handleClose}
            anchorOrigin={ui.settings.syncSnackbarLocation}
            className={css.snackbarContent}
            classes={{root: css.snackbarRoot}}
            action={[
              <Button key="undo" color="secondary" size="small" onClick={() => {site.forceReloadPage()}}>
                REFRESH
              </Button>
            ]}
          />
        </Fragment>
      } else {
        return null
      }
    }}
  </Subscription>
})



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/SyncSnackbar.tsx